// Vendors
import $ from 'jquery';

// Config
let map;
let marker;

// Init map
window.initMap = () => {
  map = new google.maps.Map(document.getElementById('map'), {
    center: window.initMarkerLocation,
    zoom: 15,
    scrollwheel: false
  });

  marker = new google.maps.Marker({
    position: window.initMarkerLocation,
    map
  });
};

document.addEventListener(
  'wpcf7submit',
  function (event) {
    // find only disbaled submit buttons
    var button = $('.wpcf7-submit[disabled]');

    // grab the old value
    var old_value = button.attr('data-value');

    // enable the button
    button.prop('disabled', false);

    // put the old value back in
    button.val(old_value);
  },
  false
);

$('form.wpcf7-form').on('submit', function () {
  var form = $(this);
  var button = form.find('input[type=submit]');
  var current_val = button.val();

  // store the current value so we can reset it later
  button.attr('data-value', current_val);

  // disable the button
  button.prop('disabled', true);

  // tell the user what's happening
  button.val('Sending, please wait...');
});
